import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enCommon from './locales/en/common.json';
import zhCommon from './locales/zh/common.json';
import enMarketing from './locales/en/marketing.json';
import zhMarketing from './locales/zh/marketing.json';
import enApp from './locales/en/app.json';
import zhApp from './locales/zh/app.json';

const resources = {
  en: {
    common: enCommon,
    marketing: enMarketing,
    app: enApp,
  },
  zh: {
    common: zhCommon,
    marketing: zhMarketing,
    app: zhApp,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh'],
    defaultNS: 'common',
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lngs, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${key} in namespace: ${ns} for languages: ${lngs.join(', ')}`);
      }
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
